import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';

import { AddTrainingPage } from './addTraining/addTraining';
import { TrainingPage } from './training/training';

@Component({
  selector: 'page-trainings',
  templateUrl: 'trainings.html',
  providers : [HttpClient]
})
export class TrainingsPage {

	trainings;
  searchQuery = '';

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  events : Events;

  	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,modalCtrl : ModalController, events : Events) {
  		this.modalCtrl = modalCtrl;
      this.httpClient = httpClient;
      this.events = events;
      this.events.subscribe('addTraining:done',()=>{
        this.httpCallTrainings('',1000);
      });
      this.events.subscribe('training:delete',()=>{
        this.httpCallTrainings('',1000);
      });
      this.events.subscribe('training:update',()=>{
        this.httpCallTrainings('',1000);
      });
      this.httpCallTrainings('',1000);
  	}

    onSearch(){
      if(this.searchQuery.length > 0){
        this.httpCallTrainings(this.searchQuery,50);
      }else{
        this.httpCallTrainings(this.searchQuery,1000);
      }
    }

    httpCallTrainings(name,max){
      this.httpClient.get('/trainings?name='+name+'&max='+max,(error,data)=>{
        this.trainings = data.json();
      });
    }

    onClickAdd(){
      this.navCtrl.push(AddTrainingPage);
    }

    onClickTraining(training){
      this.navCtrl.push(TrainingPage,{id : training.id})
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/trainings/trainings.ts